import { typeOptions } from '@/data/formData';

/**
 * Get the initials of the last name.
 * @param {string} lastName - The last name to get the initials of.
 * @returns {string} The initials of the last name.
 * @example
 * getLastNameInitials('Smith-Jones') // 'S.J.'
 * getLastNameInitials('García López') // 'G.L.'
 * getLastNameInitials('Rogers (fake employee)') // 'R.'
 * getLastNameInitials("O'Connor-Smith.") // 'O.S.'
 */
const getLastNameInitials = (lastName) => {
    if (!lastName) return '';

    // Remove any text within parentheses before processing
    // Remove potential multiple parenthesized segments
    const cleanedLastName = lastName.replace(/\([^)]*\)/g, '');

    return cleanedLastName
        .trim()
        // Split on spaces or hyphens
        .split(/[\s-]+/)
        // Remove tokens that don't have any letter (using Unicode property for letters)
        .filter((token) => /\p{L}/u.test(token))
        // Clean each token by removing extraneous punctuation from the beginning or end
        .map((token) => {
            const cleanedToken = token.replace(/^[^a-zA-ZÀ-ÿ]+|[^a-zA-ZÀ-ÿ]+$/g, '');
            return `${cleanedToken.charAt(0).toUpperCase()}.`;
        })
        .join('');
};

const displayName = (data, isEducator = true) => {
    const { preferredName, firstName, lastName } = data;
    return `${preferredName || firstName} ${isEducator ? lastName : getLastNameInitials(lastName)}`;
};

const requestTypeDisplay = (type) => {
    if (!type) {
        return '';
    }

    const typeObj = typeOptions.find((each) => each.value === type);
    return typeObj.text;
};

export {
    displayName,
    requestTypeDisplay,
    getLastNameInitials,
};
